/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OperationsTaskType } from "./OperationsTaskType";
import {
  OperationsTaskTypeFromJSON,
  OperationsTaskTypeFromJSONTyped,
  OperationsTaskTypeToJSON,
  OperationsTaskTypeToJSONTyped,
} from "./OperationsTaskType";
import type { ConversationTurn } from "./ConversationTurn";
import {
  ConversationTurnFromJSON,
  ConversationTurnFromJSONTyped,
  ConversationTurnToJSON,
  ConversationTurnToJSONTyped,
} from "./ConversationTurn";

/**
 *
 * @export
 * @interface EditOperationsTaskInput
 */
export interface EditOperationsTaskInput {
  /**
   *
   * @type {string}
   * @memberof EditOperationsTaskInput
   */
  operationsTaskId: string;
  /**
   *
   * @type {OperationsTaskType}
   * @memberof EditOperationsTaskInput
   */
  operationsTaskType: OperationsTaskType;
  /**
   *
   * @type {ConversationTurn}
   * @memberof EditOperationsTaskInput
   */
  carrierTurn?: ConversationTurn | null;
  /**
   *
   * @type {ConversationTurn}
   * @memberof EditOperationsTaskInput
   */
  customerTurn?: ConversationTurn | null;
  /**
   *
   * @type {string}
   * @memberof EditOperationsTaskInput
   */
  frontConversationId?: string | null;
}

/**
 * Check if a given object implements the EditOperationsTaskInput interface.
 */
export function instanceOfEditOperationsTaskInput(
  value: object,
): value is EditOperationsTaskInput {
  if (!("operationsTaskId" in value) || value["operationsTaskId"] === undefined)
    return false;
  if (
    !("operationsTaskType" in value) ||
    value["operationsTaskType"] === undefined
  )
    return false;
  return true;
}

export function EditOperationsTaskInputFromJSON(
  json: any,
): EditOperationsTaskInput {
  return EditOperationsTaskInputFromJSONTyped(json, false);
}

export function EditOperationsTaskInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EditOperationsTaskInput {
  if (json == null) {
    return json;
  }
  return {
    operationsTaskId: json["operationsTaskId"],
    operationsTaskType: OperationsTaskTypeFromJSON(json["operationsTaskType"]),
    carrierTurn:
      json["carrierTurn"] == null
        ? undefined
        : ConversationTurnFromJSON(json["carrierTurn"]),
    customerTurn:
      json["customerTurn"] == null
        ? undefined
        : ConversationTurnFromJSON(json["customerTurn"]),
    frontConversationId:
      json["frontConversationId"] == null
        ? undefined
        : json["frontConversationId"],
  };
}

export function EditOperationsTaskInputToJSON(
  json: any,
): EditOperationsTaskInput {
  return EditOperationsTaskInputToJSONTyped(json, false);
}

export function EditOperationsTaskInputToJSONTyped(
  value?: EditOperationsTaskInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    operationsTaskId: value["operationsTaskId"],
    operationsTaskType: OperationsTaskTypeToJSON(value["operationsTaskType"]),
    carrierTurn: ConversationTurnToJSON(value["carrierTurn"]),
    customerTurn: ConversationTurnToJSON(value["customerTurn"]),
    frontConversationId: value["frontConversationId"],
  };
}
